/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/not */
function c(n,t){return(o,r)=>!n.call(t,o,r)}export{c as not};
//# sourceMappingURL=not.mjs.map